import React,  {useState } from 'react'

import {useParams } from 'react-router-dom'
import { useFirestoreConnect } from '../../compat/reactReduxFirebase'
import { isLoaded,isEmpty  } from '../../compat/reactReduxFirebase'
//import DeviceList from './devices/List'
import { connect } from '../../compat/reactRedux'
import { compose } from '../../compat/redux'
//import { firestore } from 'firebase'
import {  getFirestore } from '../../compat/reduxFirestore'

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import {Box,Chip,Button,TextField,Alert,Switch,MenuItem,IconButton} from '@mui/material';

import ClearIcon from '@mui/icons-material/Clear';

import Loader from "../../layout/Loader"
import Page404 from "../Page404"

import { makeStyles } from '../../compat/muiStyles';
import mainStyle from "../../assets/mainStyle"
const useStyles = makeStyles((theme) => ({
  ...mainStyle,
  root: {
    //margin: '0 ',
    padding: '30px',
    width:"100%"
  },
  title:{
    color:"#444",
    textDecoration:"none",
  },
  inputItem:{
    display:"flex",
    marginBottom: "15px !important;",
    ['@media (max-width:900px)']: { 
      display:"block",
      marginBottom: "30px !important;",
    }
  },
  inputItemFieldName:{
    flexGrow:"1",
    marginTop:" 16px !important",
    marginBottom: "8px !important;",
    marginRight: "8px !important",
    ['@media (max-width:900px)']: { 
      width:"100%",
      marginRight: "",
    }
  },
  inputItemFieldUnit:{
    flexGrow:"1",
    marginTop:" 16px !important",
    marginBottom: "8px !important;",
    width:"300px",
    ['@media (max-width:900px)']: { 
      width:"100%",
    }
  },
  InputRemoveButton:{
    width:"50px",
    height:"50px"
  },
  inputGroup:{
    display:"flex",
    flexGrow:"1",
    ['@media (max-width:900px)']: { 
      width:"100%",
    }
  }
}));

const Device = ({Details,Results,Units,user,Loaded,Empty}) =>{    
        
    const classes = useStyles();

    let { id } = useParams();
    const [values, setValues] = useState({});
    const [inputs, setInputs] = useState(null);
    const [{loading, error,saved}, setStatus] = useState({});
    const [tagValues, setTagValues] = useState("");


    useFirestoreConnect([
      { collection: 'Units', storeAs: 'Units',orderBy:"name"},
        { collection: 'DeviceTypes', storeAs: 'DeviceDetails', doc:id},

    ])

        

    const handleChangeInput = (index,event) => {
      setStatus({})
      var inputsTemp = inputs?[...inputs] : Details.inputs ? Object.values(Details.inputs) : []
      inputsTemp[index][event.target.name] = event.target.value
      setInputs(inputsTemp);
    };
  
    const handleAddInput = () => {
      setStatus({})
      if(inputs)
      {
        setInputs([...inputs,{}]);
      }
      else if(Details && Details.inputs)
      {
        setInputs([...Object.values(Details.inputs),{}]);
      }
      else
      {
        setInputs([{}]);
      }
    };
  
    const handleRemoveInput = (index) => {
      setStatus({})
  
      var inputsTemp = inputs?[...inputs] : Details.inputs ? Details.inputs : []
      inputsTemp.splice(index, 1);
      setInputs(inputsTemp);
    };



        
    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };
  
    const handleCheckChange = (event) => {
      setStatus({})
      setValues({
        ...values,
        [event.target.name]: event.target.checked
      });
    };

    
  const handleTagChange = (event) => {
    setStatus({})
    setTagValues(event.target.value);
  };
  
  const handleTagPress = (event) =>{
    if (event.keyCode === 13)
    {
      event.preventDefault();
      handleTagAdd()
    }
  }

  
  const handleTagAdd = () =>
  {
    var tags = []
    if(Details && Details.tags)
      tags = [...Details.tags]

    if(values && values.tags)
      tags = [...values.tags]

    if(tagValues !== "")
    {
      tags.push(tagValues)
      setValues({
        ...values,
        tags:tags
      })
    }
    else
    {
      alert("Please add tag")
    }
    
    setTagValues("")
  }
  
  const handleTagDelete = (index) =>{
    
    var tags = null
    
    if(Details && Details.tags)
      tags = [...Details.tags]

    if(values && values.tags)
      tags = [...values.tags]

    if(!tags)
      return
      

    tags.splice(index, 1);
    
    setValues({
      ...values,
      tags:tags
    })
  }


  
    
    const handleSubmit = (event) => { 
        event.preventDefault();
        if(!Details.admin || !Details.admin.includes(user.uid))
        {
          setStatus({error:true})
          return
        }


        
        var valuesTemp = {...values}
        if(inputs)
        {
          valuesTemp.inputs = {}
          inputs.forEach((element) => {
            if(element.id)
              valuesTemp.inputs[element.id]   = element
            else if(element.name)
              valuesTemp.inputs[element.name] = element
          });
        }



        setStatus({loading:true})

        getFirestore().collection("DeviceTypes").doc(id).update(valuesTemp).then(() => {
          setStatus({saved:true})
        }).catch((error) => {
          setStatus({error:true})
          console.error("Error removing document: ", error);
        });
    }

    if(!Loaded)
    {
        return (<Loader/>)
    }

    if(Empty || !Details.admin || !Details.admin.includes(user.uid))
    {
        return (<Page404/>)
    }


        return (
            <main className={classes.root}>
                    <Box>
                        <h1>Edit Details - {Details.name}</h1>

                        <Box sx={{height:"50px"}}>
                            {error ? <Alert severity="error">Error — There was an error.</Alert> :null}
                            {loading ? <Alert severity="info">Loading  —  please wait.</Alert> :null}
                            {saved ? <Alert severity="success">Saved</Alert> :null}
                        </Box>


                        {/*Details.type ? <Box>Device: <NavLink to={"/device/"+Details.type}>{Details.type}</NavLink></Box> : null*/}
                        
                        <TextField margin="normal" fullWidth value={"name" in values ? values.name : Details.name ? Details.name : null} onChange={handleChange} name="name" className={classes.TextField} variant="outlined" label="Name" />
                        <TextField margin="normal" fullWidth value={"url" in values ? values.url : Details.url ? Details.url : null}  onChange={handleChange} name="url" className={classes.TextField} variant="outlined" label="URL" />
                        <TextField margin="normal" fullWidth value={"urlBuy" in values ? values.urlBuy : Details.urlBuy ? Details.urlBuy : null}  onChange={handleChange} name="urlBuy" className={classes.TextField} variant="outlined" label="Buy URL" />
                        <TextField margin="normal" fullWidth value={"urlMake" in values ? values.urlMake : Details.urlMake ? Details.urlMake : null}  onChange={handleChange} name="urlMake" className={classes.TextField} variant="outlined" label="Instruction URL" />
                        <TextField margin="normal" fullWidth value={"image" in values ? values.image : Details.image ? Details.image : null}  onChange={handleChange} name="image" className={classes.TextField} variant="outlined" label="Image URL" />
                        
                        
                        <Box sx={{display:"flex", marginBottom:"10px", marginTop:"20px"}}>
                        <p>Tags:</p>
                      <TextField  sx={{margin:" 0 10px  "}} fullWidth name="addTag" id="addTagIdInput" value={tagValues} onChange={handleTagChange} onKeyUp={handleTagPress} variant="outlined" />
                      <Button  variant="contained" onClick={handleTagAdd}>Add</Button>

                        </Box>
                        <Box sx={{display:"flex",marginBottom:"20px",}}>
                        {("tags" in values?values.tags : Details.tags?Details.tags:[]).map((item,index)=>{
                          return(<Chip label={item}  sx={{marginRight:"10px",}} variant="outlined" onDelete={()=>handleTagDelete(index)} />)
                        })}
                        </Box>
                        




                        <Box sx={{marginBottom:"50px"}}>
                          <h3>Inputs</h3>
                          <Box>
                            {(inputs ? inputs : Details.inputs ? Object.values(Details.inputs) : []).map((item,index)=>{
                              return(<Box className={classes.inputItem}>
                                <TextField margin="normal" fullWidth value={item.name ? item.name : null} onChange={(event)=>handleChangeInput(index,event)} name="name"  className={classes.inputItemFieldName} variant="outlined" label="Input Name" />
                              <Box className={classes.inputGroup}>
                              <TextField  select label="Unit"  className={classes.inputItemFieldUnit} name="unit"  defaultValue="Unknown" value={item.unit ? item.unit : "Unknown"} onChange={(event)=>handleChangeInput(index,event)}  >
                                  {Units && Units.map((option) => {
                                   if( !option.id || !option.name)
                                   return null

                                 if(option.id == "Unknown" )
                                   return(<MenuItem  disabled value={option.id}>
                                     {option.name} {option.unitSymbol ? "("+option.unitSymbol+")" :null}
                                   </MenuItem>)

                                    return(<MenuItem value={option.id}>
                                             {option.name} {option.unitSymbol ? "("+option.unitSymbol+")" :null}
                                           </MenuItem>)
                                  })}
                                </TextField>

                                  <Box sx={{padding:"20px"}}>
                                    <IconButton className={classes.InputRemoveButton} color="primary" aria-label="Remove input" onClick={()=>handleRemoveInput(index)} >
                                      <ClearIcon />
                                    </IconButton>
                                  </Box>
                                  </Box>
                                
                              </Box>)
                            })}
                            <Button  variant="contained" onClick={handleAddInput}>Add inputs</Button>
                          </Box>
                        </Box>






                        <TextField margin="normal" fullWidth value={"description" in values ? values.description : Details.description ? Details.description : null} onChange={handleChange} name="description" className={classes.TextField} variant="outlined" label="Description" multiline rows={4}/>
                        
                      <Box sx={{display:"flex"}}>
                        <Box sx={{margin:" 8px 20px 8px 0",}}>Private</Box>
                        <Switch
                          checked={"private" in values ? values.private : Details && "private" in Details  ? Details.private : false  }
                          name="private"
                          onChange={handleCheckChange}
                        />
                      </Box>



                        {/*

                        {Details.inputs ? <Box>
                                <h2>Inputs</h2>
                                <ul>
                                    { inputs && inputs.map(input => {
                                        return (<li>{input}</li>)
                                    })}
                                </ul>  
                                </Box> : null*/}

                            <br/>

                            <Button margin="normal" onClick={handleSubmit}  type="submit" className={classes.SendButton} variant="contained">Save</Button>

                    </Box>
            </main>
        )
}



const mapStateToProps = (state) => {

    var DeviceDetails = null;
    if(state.firestore.ordered.DeviceDetails)
    DeviceDetails = state.firestore.ordered.DeviceDetails[0];

    return {
        user:firebase.auth().currentUser,
        Details:DeviceDetails,
        Units:state.firestore.ordered.Units,
        Loaded:isLoaded(state.firestore.ordered.DeviceDetails,state.firestore.ordered.Units),
        Empty:isEmpty(state.firestore.ordered.DeviceDetails,state.firestore.ordered.Units) 
    }
}

export default compose(
    connect(mapStateToProps),
    
)(Device);